import { CustomerContact, CustomerContactListItem } from '../types/customer-contact';

export const emptyContactForm = {
  customer_id: '',
  name: '',
  email: '',
  phone: '',
  title: '',
  street: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  notes: '',
  is_primary: false,
};

export const formatAddress = (contact: CustomerContact | CustomerContactListItem): string => {
  const parts = [
    'street' in contact ? contact.street : null,
    'city' in contact ? contact.city : null,
    'state' in contact ? contact.state : null,
    'zip' in contact ? contact.zip : null,
    'country' in contact ? contact.country : null,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : '-';
};
